// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueModeleInvest = (value) => ({
  type: actionTypes.SET_VALUE_ModeleInvest,
  payload: value,
});

export const setTypeModeleInvest = (type) => ({
  type: actionTypes.SET_TYPE_ModeleInvest,
  payload: type,
});
export const setActifModeleInvest = (actif) => ({
  type: actionTypes.SET_ACTIF_ModeleInvest,
  payload: actif,
});

export const setCurrentPageModeleInvest = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_ModeleInvest,
  payload: page,
});

export const setOrderModeleInvest = (order) => ({
  type: actionTypes.SET_ORDER_ModeleInvest,
  payload: order,
});

export const setSortFieldModeleInvest = (field) => ({
  type: actionTypes.SET_SORT_FIELD_ModeleInvest,
  payload: field,
});
export const setCategorieModeleInvest = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_ModeleInvest,
  payload: categorie,
});
